// src/components/Tickets/InvoiceTicketButton.js

import { useMemo } from "react"

import NewTicketDrawer from "./NewTicketDrawer"
import { useCollection } from "../../hooks/useCollection"

const InvoiceTicketButton = ({ invoice = {}, user, allInvoices = [] }) => {
  // We need all users to find the accountants
  const { data: usersData } = useCollection("users")

  // This is where you define the special autofill rules for an invoice ticket
  const initialFormValues = useMemo(() => {
    if (!usersData) return {}

    // Find all users with the 'accountant' role
    const accountantIds = usersData
      .filter((u) => u.group?.includes("accountant")) // Use optional chaining for safety
      .map((u) => u.id)

    return {
      issueType: "Change Request",
      assignedTo: accountantIds,
    }
  }, [usersData])

  // Define what happens when an invoice ticket is created (optional)
  const handleInvoiceTicketCreate = (batch, { contextId, assignedToIds }) => {
    // For now, we don't need to update the invoice document, but you could add logic here later.
    // For example:
    // const invoiceRef = doc(db, "invoices", contextId);
    // batch.update(invoiceRef, { hasOpenTicket: true });
    console.log(`Ticket created for invoice ${contextId}. Assigned to:`, assignedToIds)
  }

  return (
    <NewTicketDrawer
      contextItem={invoice}
      contextType="Invoice"
      selectableItems={allInvoices}
      onTicketCreate={handleInvoiceTicketCreate}
      initialFormValues={initialFormValues}
    />
  )
}

export default InvoiceTicketButton
